import React from 'react';
import { rowBox, section } from './IncentiveRuleModal.styles';
import { monthLabel } from './IncentiveRuleModal.constants';

export default function IncentiveRuleVersionTimeline({ versions = [] }) {
  if (!versions.length) return null;

  return (
    <div style={{ ...section, ...rowBox, background: 'rgba(15,118,110,0.06)' }}>
      <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--text)', marginBottom: 6 }}>
        적용 이력
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {versions.map((version) => (
          <span
            key={version.id || version.effective_from_month}
            style={{
              fontSize: 11,
              fontWeight: 800,
              color: '#0f766e',
              background: 'rgba(15,118,110,0.12)',
              borderRadius: 999,
              padding: '3px 8px',
            }}
          >
            {monthLabel(version.effective_from_month)}
          </span>
        ))}
      </div>
    </div>
  );
}
